import domready from 'domready';
domready(function () {
  var $configuration = document.getElementById("booking-departure-configuration");
  if (!$configuration) {
    return;
  }
  var $personPrices = $configuration.querySelectorAll("[data-person-price]");
  var $addPersonButton = $configuration.querySelector("[data-add-person]");
  var $removePersonButton = $configuration.querySelector("[data-remove-person]");
  var $departurePicker = $configuration.querySelector(".tripdate");
  var $departure = document.getElementById("selectedDeparture");
  var $personCount = document.getElementById("person-count");
  var departureChanged = new CustomEvent("departureChanged");
  var personCountChanged = new CustomEvent("personCountChanged");
  var personPriceChanged = new CustomEvent("personPriceChanged");
  var $buttons = $configuration.getElementsByClassName("button");
  const additionalServicesCheckboxes = document.querySelectorAll('input[id^="booking-additional-services"]');
  const donationInput = document.querySelector('#booking-donation-amount');

  Array.prototype.forEach.call($buttons, function (el) {
    el.addEventListener("click", function (event) {
      event.preventDefault();
    });
  });

  if ($departurePicker) {
    $departurePicker.addEventListener("change", function (event) {
      var $departureParent = $departurePicker.parentElement;
      var duration = Math.max(parseInt($departureParent.dataset.duration) || 1, 1);
      var fromDate = stringToDate($departurePicker.value, "dd.mm.yyyy", ".");
      var untilDate = new Date(fromDate.setTime(fromDate.getTime() + (duration -1) * 86400000));
      $departure.value = $departurePicker.value + " - " + (untilDate.getDate() < 10 ? "0" : "") + untilDate.getDate() + "." + (untilDate.getMonth() < 9 ? "0" : "") + (untilDate.getMonth() + 1) + "." + untilDate.getFullYear();
      $configuration.dispatchEvent(departureChanged);
    });
  }

  $configuration.addEventListener("personCountChanged", function (event) {
    var maximumPersons = $personPrices.length;
    var minimumPersons = Array.prototype.filter.call($personPrices, function (element) {
      if (("personPriceMin" in element.dataset)) {
        return element;
      }
    }).length;
    var currentPersons = parseInt($personCount.value);
    var visiblePersons = Array.prototype.filter.call($configuration.querySelectorAll("[data-person-price-selector]"), function (element) {
      if (element.parentElement.offsetWidth > 0 && element.parentElement.offsetHeight > 0) {
        return element;
      }
    }).length;
    if (maximumPersons === minimumPersons) {
      $addPersonButton.style.display = "none";
      $removePersonButton.style.display = "none";
    } else {
      if (currentPersons >= maximumPersons) {
        $addPersonButton.style.display = "none";
      } else {
        $addPersonButton.style.display = "block";
      }
      if (currentPersons === 1 || currentPersons <= minimumPersons) {
        $removePersonButton.style.display = "none";
      } else {
        $removePersonButton.style.display = "block";
      }
    }
    var $elements;
    var priceArray = Array.from($personPrices);
    if (currentPersons > visiblePersons) {
      $elements = priceArray.slice(0, currentPersons);
      Array.prototype.forEach.call($elements, function (el) {
        el.style.display = "";
        if (el.tagName === "SELECT") {
          var $select = el.querySelector("[data-person-price-selector]");
          $select.setAttribute("disabled", false);
        }
      });
    } else if (currentPersons < visiblePersons) {
      $elements = priceArray.slice(currentPersons);
      Array.prototype.forEach.call($elements, function (el) {
        el.style.display = "none";
        if (el.tagName === "SELECT") {
          var $select = el.querySelector("[data-person-price-selector]");
          $select.setAttribute("disabled", true);
        }
      });
    }
  });

  $addPersonButton.addEventListener("click", function (event) {
    var personCount = parseInt($personCount.value);
    $personCount.value = personCount + 1;
    $configuration.dispatchEvent(personCountChanged);
  });

  $removePersonButton.addEventListener("click", function (event) {
    var personCount = parseInt($personCount.value);
    $personCount.value = personCount - 1;
    $configuration.dispatchEvent(personCountChanged);
  });

  Array.prototype.forEach.call($personPrices, function (el) {
    el.addEventListener("change", function (event) {
      $configuration.dispatchEvent(personPriceChanged);
      // @todo: do we really need this
      var target = event.target;
      target.dispatchEvent(personPriceChanged);
    });
  });

  $configuration.dispatchEvent(personCountChanged);

  // Listen for a change on one of the additional services checkboxes
  if (additionalServicesCheckboxes) {
    additionalServicesCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        $configuration.dispatchEvent(new CustomEvent("additionalServicesChange"));
      })
    })
  }

  // List for a change on the donation input
  if (donationInput) {
    donationInput.addEventListener('input', () => {
      if (donationInput.value === '') donationInput.value = 0;
      $configuration.dispatchEvent(new CustomEvent("donationInputChange"));
    })
  }
});

function stringToDate(_date, _format, _delimiter) {
  var formatLowerCase = _format.toLowerCase();
  var formatItems = formatLowerCase.split(_delimiter);
  var dateItems = _date.split(_delimiter);
  var monthIndex = formatItems.indexOf("mm");
  var dayIndex = formatItems.indexOf("dd");
  var yearIndex = formatItems.indexOf("yyyy");
  var month = parseInt(dateItems[monthIndex]);
  month -= 1;
  return new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
}
